export interface UploadDocumentDto {
  moduleType: ModuleType;
  invoiceId: number | null;
  orderId: number | null;
  loanId: number | null;
  eventId: number | null;
  documentType: string;
  source: string | null;
  file: File;
  description: string | null;
}

export enum ModuleType {
  ORDER = "Order",
  LOAN = "Loan",
  EVENT = "Event",
}
